import {Component, ViewEncapsulation, Inject, AfterViewInit} from "@angular/core";
import {CostGuideUtils} from "../../../../common/utils/costguideutils";
import {TransferState} from "../../../modules/transfer-state/transfer-state";

declare var Modernizr: any;

@Component({
  templateUrl: './menu.component.html',
  selector: 'menu',
  styleUrls: [ './menu.component.scss' ],
  encapsulation: ViewEncapsulation.None
})


export class MenuComponent implements AfterViewInit {

  public docscroll:number = 0;
  public transEndEventName:string;
  public static isMenuOpened:boolean = false;
  public static isOpeningOrClosingMenu:boolean = false;

  constructor(@Inject('isBrowser') protected isBrowser: boolean,
              protected cache: TransferState,
              protected costGuideUtils: CostGuideUtils) {}

  ngAfterViewInit() {

    if(this.isBrowser) {
      this.loadMenu();
    }

  }

  public  scrollY() {
    return window.pageYOffset || window.document.documentElement.scrollTop;
  }

  public loadMenu() {
    let transEndEventNames = {
      'WebkitTransition': 'webkitTransitionEnd',
      'MozTransition': 'transitionend',
      'OTransition': 'oTransitionEnd',
      'msTransition': 'MSTransitionEnd',
      'transition': 'transitionend'
    };

    this.transEndEventName = transEndEventNames[ window['Modernizr'].prefixed( 'transition' ) ];

    $(document).on("click", ".hamburger-button", (ev) => {
      if(!MenuComponent.isOpeningOrClosingMenu) {
        if(!MenuComponent.isMenuOpened) {
          this.openMenu(ev);
        }
        else {
          this.closeMenu(ev);
        }
      }
    });

    $(document).on("click", ".menu-container", (ev) => {
      if(!MenuComponent.isOpeningOrClosingMenu) {
        if (MenuComponent.isMenuOpened) {
          this.closeMenu(ev);
        }
      }
    });

    $(document).on("click", "#menu-perspective", (ev) => {return false; } );

  }

  public  openMenu(ev) {
    MenuComponent.isOpeningOrClosingMenu = true;
    MenuComponent.isMenuOpened = true;
    $('.hamburger-button').addClass('is-active');
    $('.hamburger-inner').removeClass('hamburger-inner-custom');
    ev.stopPropagation();
    ev.preventDefault();
    this.docscroll = this.scrollY();
    // change top of contentWrapper
    $('.menu-wrapper').css('top', (this.docscroll * -1) + 'px');
    // mac chrome issue:
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    // add modalview class
    $('.menu-perspective').addClass('modalview');
    // animate..
    setTimeout(() => {
      this.preloadData();
      $('.menu-perspective').addClass('animate');
      MenuComponent.isOpeningOrClosingMenu = false;
    }, 25 );
  }

  public preloadData() {

    let costGuideTitlesKey = 'cost-guide-titles';
    let costGuideViewFromCache = this.cache.get(costGuideTitlesKey);
    if(costGuideViewFromCache == null) {
      let costGuideView = this.costGuideUtils.loadCostGuidesTitlesByGroupAndCategory();
      //avoid call twice from client by storing the data in the cache
      costGuideView.subscribe(data => {
        this.cache.set(costGuideTitlesKey, data);
      });
    }

  }

  public  closeMenu(ev) {
    MenuComponent.isOpeningOrClosingMenu = true;
    MenuComponent.isMenuOpened = false;
    $('.hamburger-button').removeClass('is-active');
    $('.hamburger-inner').addClass('hamburger-inner-custom');
    $('.menu-container').addClass('transform');
    if( $('.menu-perspective').hasClass('animate') ) {
      $('.menu-perspective').on( this.transEndEventName, (ev) => this.onEndTransFn(ev) );
      $('.menu-perspective').removeClass('animate');
    }
  }

  public onEndTransFn( ev ) {
    if ( $(ev.target).hasClass('menu-container') || $(ev.target).hasClass('transform') ) return;
    $('.menu-perspective').off(this.transEndEventName );
    $('.menu-perspective').removeClass('modalview');
    $('.menu-container').removeClass('transform');
    // mac chrome issue:
    document.body.scrollTop = document.documentElement.scrollTop = this.docscroll;
    // change top of contentWrapper
    $('.menu-wrapper').css('top', '0px');
    MenuComponent.isOpeningOrClosingMenu = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/menu/menu.component.ts